<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Movimiento de stock
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Movimiento de stock</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div *ngIf="
                    formHeader.get('fechaDesde').invalid &&
                    (formHeader.get('fechaDesde').dirty ||
                    formHeader.get('fechaDesde').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div *ngIf="
                    formHeader.get('fechaHasta').invalid &&
                    (formHeader.get('fechaHasta').dirty ||
                    formHeader.get('fechaHasta').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Rubro" formControlName="rubro"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="familia"></mdb-select>
            <label>Familia</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFormato" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
            <label>Formato</label>
          </div>
        </div>
      </div>

      <div class="row filtros-body">
        <div class="col" style="max-width: 190px;">
          <mdb-checkbox formControlName="mayorCero">Saldo Mayor a 0</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 190px;">
          <mdb-checkbox formControlName="igualCero">Saldo Iguales a 0</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 300px;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" id="materialInlineActivo" mdbInput [value]="TIPO_ACTIVO"
              formControlName="activo" />
            <label class="form-check-label" for="materialInlineActivo">Activo</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInlineInactivo" mdbInput [value]="TIPO_INACTIVO"
              formControlName="activo" />
            <label class="form-check-label" for="materialInlineInactivo">Inactivo</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="codProduct" class="form-control" placeholder="000" #codProduct
              formControlName="sku" />
            <label for="codProduct">Código de producto</label>
            <!-- <div *ngIf="
                            formHeader.get('sku').invalid &&
                            (formHeader.get('sku').dirty ||
                            formHeader.get('sku').touched)
                          ">
                      <mdb-error *ngIf="formHeader.get('sku').hasError('required')">
                        Ingrese código de producto
                      </mdb-error>
                      <mdb-error *ngIf="formHeader.get('sku').hasError('min')">
                        Código de producto debe ser mayor a 0 </mdb-error>
                    </div> -->
          </div>
        </div>
        <div class="col d-flex">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarProducto()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
            {{ productoSeleccionado.descripcion}}
          </h6>
        </div>
        <!-- <div class="col" style="max-width: 190px;">
          <mdb-checkbox formControlName="incluirMovDemanda">Incluir Movimiento por Analisis demanda</mdb-checkbox>
        </div> -->
      </div>


    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaMovimientos">

      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th rowspan="2" scope="col">Fecha</th>
            <th rowspan="2" scope="col" *ngIf="!conProducto">SKU</th>
            <th rowspan="2" scope="col" *ngIf="!conProducto">Producto</th>
            <!-- <th scope="col">Formato</th> -->
            <th rowspan="2" scope="col">Bodega</th>
            <th rowspan="2" scope="col" *ngIf="!conProducto">Rubro</th>
            <th rowspan="2" scope="col" *ngIf="!conProducto">Familia</th>
            <th rowspan="2" scope="col">Documento</th>
            <th rowspan="2" scope="col">Rec.</th>
            <th rowspan="2" scope="col" *ngIf="conProducto">RUT</th>
            <th rowspan="2" scope="col" *ngIf="conProducto">Cliente</th>
            <th colspan="2" scope="col" class="text-center">Ingresos</th>
            <th colspan="2" scope="col" class="text-center">Salidas</th>
            <th colspan="2" scope="col" class="text-center">Saldos</th>
            <!-- <th scope="col" class="doble-linea">Tipo Movim.</th> -->
            <!-- <th scope="col" class="doble-linea text-right">Saldo Inicial</th> -->
            <!-- <th scope="col" class="text-right">Ingresos</th> -->
            <!-- <th scope="col" class="text-right">Salidas</th> -->
            <!-- <th scope="col" class="doble-linea text-right">Saldo actual</th> -->
          </tr>
          <tr>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let movimiento of listaMovimientos">
            <!-- FILA SALDO INICIAL -->
            <!-- <tr *ngIf="movimiento.esFilaSaldoInicial" class="font-weight-bold">
              <td></td>
              <td><span *ngIf="!conProducto">{{ movimiento.sku }}</span></td>
              <td><span *ngIf="!conProducto">{{ movimiento.producto_descripcion }}</span></td>
              <td [attr.colspan]="conProducto ? 7 : 9" class="text-right">Saldo Anterior:</td>
              <td class="border-left border-right text-right">{{movimiento.saldoCantidad}}</td>
              <td class="border-right text-right">{{movimiento.saldoFraccion}}</td>
            </tr> -->
            <!-- FILA MOVIMIENTO -->
            <tr *ngIf="!movimiento.esFilaSaldoInicial">
              <td>{{movimiento.fecha_movimiento | fecha}}</td>
              <td *ngIf="!conProducto">{{movimiento.sku}}</td>
              <td *ngIf="!conProducto">{{movimiento.producto_descripcion}}</td>
              <!-- <td>{{movimiento.formato_nombre}}</td> -->
              <td>{{movimiento.bodega_nombre}}</td>
              <td *ngIf="!conProducto">{{movimiento.rubro_nombre}}</td>
              <td *ngIf="!conProducto">{{movimiento.familia_nombre}}</td>
              <td>{{movimiento.documento}}</td>
              <td class="text-center">{{movimiento.recorrido_codigo}}</td>
              <td *ngIf="conProducto">{{movimiento.rutFormato | rut}}</td>
              <td *ngIf="conProducto">{{movimiento.cliente_proveedor_nombre}}</td>
              <td class="border-left border-right text-right">{{movimiento.ingresosCantidad}}</td>
              <td class="border-right text-right">{{movimiento.ingresosFraccion}}</td>
              <td class="border-left border-right text-right">{{movimiento.salidasCantidad}}</td>
              <td class="border-right text-right">{{movimiento.salidasFraccion}}</td>
              <td class="border-left border-right text-right">{{movimiento.saldoCantidad}}</td>
              <td class="border-right text-right">{{movimiento.saldoFraccion}}</td>
            </tr>
          </ng-container>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>

      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="exportarExcel()">
      Excel
    </button>

    <!-- <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      PDF
    </button> -->
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto 
  [showFiltroActivoInactivo]="true"
  (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado($event)">
</app-modal-seleccionar-producto>
